import { NgClass } from '@angular/common';
import { Component, input, ViewEncapsulation } from '@angular/core';

import { SVG_ICON_IMPORTS } from '@valk-nx/helpers/lib/svg-unique-ids/svg-unique-ids.directive';

@Component({
	encapsulation: ViewEncapsulation.None,
	imports: [SVG_ICON_IMPORTS, NgClass],
	selector: 'vp-accordion',
	templateUrl: './accordion.html',
})
export class AccordionComponent {
	variant = input<'accent' | 'base'>('base');
	title = input<string>('');
	isOpen = input<boolean>(false);
}
